// Sentry must init before any other meaningful module work.
import { initSentry } from "@engagexp/observability";
initSentry({
  product: "sigil",
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.PROD ? "production" : "development",
  release: import.meta.env.VITE_APP_VERSION,
});

import { createRoot } from "react-dom/client";
import { AnalyticsProvider } from "@engagexp/analytics";
import App from "./app/App";
import "./styles/index.css";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ??
  "https://us.i.posthog.com";

createRoot(document.getElementById("root")!).render(
  <AnalyticsProvider
    product="sigil"
    apiKey={POSTHOG_KEY ?? ""}
    apiHost={POSTHOG_HOST}
    environment={import.meta.env.PROD ? "production" : "development"}
    platform="web"
    disabled={!POSTHOG_KEY}
  >
    <App />
  </AnalyticsProvider>,
);
